import round from 'lodash/round';

export default (value, totalValue) => {
    return round(value * (100 / totalValue), 2);
}